var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"loading":true,"lines":10}}),(_vm.$route.query.benefitsPayload)?_c('form',{ref:"benefitsForm",attrs:{"action":"https://www.mystaffshop.co.uk/SSO/DoIBenefitSSO/","method":"post"}},[_c('input',{attrs:{"type":"hidden","name":"SAMLResponse"},domProps:{"value":_vm.benefitsSAML}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }